module.exports = __webpack_public_path__ + "static/media/Assets-09-Capital-halftone.a053e0f5.jpg";